import MyContext from "../../../contexts/MyContext";
import { TicketForm4 } from "../ticket-forms/TicketForm4";

export const Slide4 = (props) => {
  return <MyContext.Consumer>{(context) => <div hidden={context.activeSlide !== 3}>{<TicketForm4 {...props} />}</div>}</MyContext.Consumer>;
};
